module.exports = __webpack_public_path__ + "media/images/design/images/pickup_img01-de653675697f4410be661b418bb35df1.jpg";